var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "40%",
            "modal-append-to-body": "",
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                size: "small",
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "180px",
                "validate-on-rule-change": false,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "协议名称", prop: "agreementName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%", "margin-right": "20px" },
                      attrs: {
                        disabled: _vm.optionType === "view",
                        size: "small",
                        placeholder: "请选择协议名称",
                        clearable: "",
                      },
                      on: { change: _vm.agreementChange },
                      model: {
                        value: _vm.form.agreementName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "agreementName", $$v)
                        },
                        expression: "form.agreementName",
                      },
                    },
                    _vm._l(_vm.protocolList.value, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "协议版本", prop: "agreementVersion" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%", "margin-right": "20px" },
                      attrs: {
                        disabled: _vm.optionType === "view",
                        size: "small",
                        placeholder: "请选择协议版本",
                        clearable: "",
                      },
                      on: { change: _vm.versionChange },
                      model: {
                        value: _vm.form.agreementVersion,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "agreementVersion", $$v)
                        },
                        expression: "form.agreementVersion",
                      },
                    },
                    _vm._l(_vm.agreementVersion, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.agreementVersion,
                          value: item.agreementVersion,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "渠道选择", prop: "channelType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.channelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelType", $$v)
                        },
                        expression: "form.channelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.channelType === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "指定渠道", prop: "channelIds" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        on: {
                          focus: function ($event) {
                            return _vm.channelInputClick(_vm.item)
                          },
                        },
                        model: {
                          value: _vm.form.channelIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "channelIds", $$v)
                          },
                          expression: "form.channelIds",
                        },
                      }),
                      _c("channel-popups", {
                        attrs: {
                          isAppendToBody: true,
                          modelIsAppendToBody: false,
                          "app-id": _vm.form.channels.channelId,
                          visible: _vm.channelVisible,
                          multiple: true,
                        },
                        on: {
                          "update:visible": function ($event) {
                            _vm.channelVisible = $event
                          },
                          comfirm: function ($event) {
                            return _vm.channelConfirm($event, _vm.item)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "发端", prop: "senderPlatforms" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.senderPlatformsChange },
                      model: {
                        value: _vm.senderPlatforms,
                        callback: function ($$v) {
                          _vm.senderPlatforms = $$v
                        },
                        expression: "senderPlatforms",
                      },
                    },
                    _vm._l(_vm.sendPlatform.value, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收端", prop: "receiverPlatforms" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.receiverPlatformsChange },
                      model: {
                        value: _vm.receiverPlatforms,
                        callback: function ($$v) {
                          _vm.receiverPlatforms = $$v
                        },
                        expression: "receiverPlatforms",
                      },
                    },
                    _vm._l(_vm.receivePlatform.value, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._l(
                _vm.form.senderPlatforms,
                function (senderPlatform, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: index,
                      attrs: {
                        label: `发端 ${senderPlatform.label}版本`,
                        prop: `senderPlatforms.${index}.minClientVersion`,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              size: "small",
                              maxlength: "200",
                              placeholder: "请输入最小版本",
                              clearable: "",
                            },
                            model: {
                              value: senderPlatform.minClientVersion,
                              callback: function ($$v) {
                                _vm.$set(
                                  senderPlatform,
                                  "minClientVersion",
                                  $$v
                                )
                              },
                              expression: "senderPlatform.minClientVersion",
                            },
                          }),
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              maxlength: "200",
                              placeholder: "请输入最大版本",
                              clearable: "",
                            },
                            model: {
                              value: senderPlatform.maxClientVersion,
                              callback: function ($$v) {
                                _vm.$set(
                                  senderPlatform,
                                  "maxClientVersion",
                                  $$v
                                )
                              },
                              expression: "senderPlatform.maxClientVersion",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }
              ),
              _vm._l(
                _vm.form.receiverPlatforms,
                function (receiverPlatform, index) {
                  return _c(
                    "el-form-item",
                    {
                      key: index,
                      attrs: {
                        label: `收端 ${receiverPlatform.label}版本`,
                        prop: `receiverPlatforms.${index}.minClientVersion`,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-right": "10px" },
                            attrs: {
                              size: "small",
                              maxlength: "200",
                              placeholder: "请输入最小版本",
                              clearable: "",
                            },
                            model: {
                              value: receiverPlatform.minClientVersion,
                              callback: function ($$v) {
                                _vm.$set(
                                  receiverPlatform,
                                  "minClientVersion",
                                  $$v
                                )
                              },
                              expression: "receiverPlatform.minClientVersion",
                            },
                          }),
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              maxlength: "200",
                              placeholder: "请输入最大版本",
                              clearable: "",
                            },
                            model: {
                              value: receiverPlatform.maxClientVersion,
                              callback: function ($$v) {
                                _vm.$set(
                                  receiverPlatform,
                                  "maxClientVersion",
                                  $$v
                                )
                              },
                              expression: "receiverPlatform.maxClientVersion",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }
              ),
              _c(
                "el-form-item",
                { attrs: { label: "说明", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      maxlength: "200",
                      placeholder: "请输入说明",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否需要弹窗", prop: "popup" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.popup,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "popup", $$v)
                        },
                        expression: "form.popup",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "协议地址" } }, [
                _c("span", [_vm._v(_vm._s(_vm.form.agreementUrl))]),
              ]),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Publish", { ref: "publish", on: { isSubmit: _vm.submitChange } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }